import { Box, Switch } from "@mui/material"
import PreventRefresh from "../../core/components/utils/PreventRefresh"
import ReworkItemTracker from "../tracker/ReworkitemTracker"
import ReworkChildSongTracker from "../tracker/ReworkChildSongTracker"
import ReworkWarpSongTracker from "../tracker/ReworkWarpSongTracker"
import ReworkDungeonTracker from "../tracker/ReworkDungeonTracker"
import RewardRewardTracker, { RewardDto, RewardEnum } from "../tracker/ReworkRewardTracker"
import ReworkTrialTracker, { TrialEnum } from "../tracker/ReworkTrialTracker"
import AdditionalItemTracker from "../tracker/AdditionalItemTracker"
import ReworkPathTracker from "../tracker/ReworkPathTracker"
import ReworkSometimesTracker from "../tracker/ReworkSometimesTracker"
import { clone, cloneDeep } from "lodash"
import { BossDto } from "../hints/BossAutocomplete"
import { DefaultLocation, LocationAutocompleteDto, LocationDto } from "../locations/LocationDtos"
import { HintRandomizerDto, MultiworldAwlays } from "../hints/HintsAutocomplete"
import { useState } from "react"
import { DungeonDto, DungeonEnum, Dungeons } from "../dungeon/DungeonDto"
import { DefaultSometimeHint, SometimeHintProps } from "../hints/SometimesHint"
import { DefaultGoalHintDto, GoalHintDto } from "../hints/PathHintsTracker"
import { OotItemDto } from "../hints/OotItemAutocomplete"
import OotItemContextMenuButton from "../hints/OotItemContextMenuButton"
import { MultiworldPlayerAutocomplete } from "./PlayerAutocomplete"
import DefaultAlwaysHint from "../hints/AlwaysHints"
import ShopsanityTracker from "../shop/ShopsanityTracker"
import SettingsUiDisplay from "../rsl/setting/base/SettingsUiDisplay"
import { MedallionProps } from "../inventory/medallions/MedallionInterface"
import GoalAutocomplete from "../hints/GoalAutocomplete"
import LightSphereTracker from "../sphere/LigthSphereTracker"
import Hookshot from "../../core/assets/oot/classic/OoT_Hookshot_Icon.png"
import { BaseLocationAutocomplete } from "../hints/LocationAutocomplete"

const MultiworldTracker = () => {

    let players = ["Deep", "LaPedr", "Volc"];
    
        let warp = 0;
        let gerudoCard = 0;
        let trials = 1;
        let fountain = 1;
    
        let [gbk, setGbk] = useState(0)
        let [bridge, setBridge] = useState(0)
        let [scarecrow, setScarecrow] = useState(0)
        let [token, setToken,] = useState(0)
        let [woth, setWoth,] = useState(false)

        let [hookPlayer1, setHookPlayer1,] = useState<LocationDto |null>(null)
        let [hookPlayer2, setHookPlayer2,] = useState<LocationDto |null>(null)
        let [hookPlayer3, setHookPlayer3,] = useState<LocationDto |null>(null)
    

        let [goalHints, setGoalHints] = useState<Array<GoalHintDto>>([DefaultGoalHintDto,DefaultGoalHintDto,DefaultGoalHintDto,DefaultGoalHintDto,DefaultGoalHintDto])
    
        let [sometimes, setSometimes] = useState<Array<SometimeHintProps>>([...Array(21)].map(i => DefaultSometimeHint));
    
        //dungeons
    
        let [dungeons, setDungeons] = useState<Array<DungeonDto>>([...Dungeons])
    
        const setDungeonValue = (value: DungeonDto, dungeon: DungeonEnum) => {
            setDungeons([...dungeons.filter(x => x.id !== dungeon), value]);
        }

          let [rewards, setRewards] = useState<Array<RewardDto>>([
            {
              id: RewardEnum.KokiriEmerald,
              settings: { isObtained: false, indexLabel: 0 },
            },
          ]);

          const setReward = (r: RewardEnum, props: MedallionProps) => {
            setRewards([
              ...rewards.filter((x) => x.id !== r),
              { id: r, settings: props },
            ]);
          };
    
        //trials
    
        let [forestActivated, setForestActivated] = useState<boolean>(false)
        let [fireActivated, setFireActivated] = useState<boolean>(false)
        let [waterActivated, setWaterActivated] = useState<boolean>(false)
        let [shadowActivated, setShadowActivated] = useState<boolean>(false)
        let [spiritActivated, setSpiritActivated] = useState<boolean>(false)
        let [lightActivated, setLightActivated] = useState<boolean>(false)
    
    
        const setTrialActivated = (trial: TrialEnum, value: boolean) => {
            switch (trial) {
                case TrialEnum.Forest:
                    setForestActivated(value);
                    break;
                case TrialEnum.Fire:
                    setFireActivated(value);
                    break;
                case TrialEnum.Water:
                    setWaterActivated(value);
                    break;
                case TrialEnum.Shadow:
                    setShadowActivated(value);
                    break;
                case TrialEnum.Spirit:
                    setSpiritActivated(value);
                    break;
                case TrialEnum.Light:
                    setLightActivated(value);
                    break;
                default:
                    break;
            }
    
        }
    
    
        const setSometimesState = (state: number, index: number) => {
            if(index === sometimes.length -1)
                setSometimes([...sometimes.slice(0,index), {...sometimes[index], state: state}])
            else if(index === 0)
                setSometimes([{...sometimes[index], state: state}, ...sometimes.slice(index+1,sometimes.length) ])
            else
                setSometimes([...sometimes.slice(0,index), {...sometimes[index], state: state}, ...sometimes.slice(index+1,sometimes.length)])
        }
    
        const setSometimesHint = (hint: HintRandomizerDto | null, index: number) => {
            if(index === sometimes.length -1)
                setSometimes([...sometimes.slice(0,index), {...sometimes[index], hint: hint}])
            else if(index === 0)
                setSometimes([{...sometimes[index], hint: hint}, ...sometimes.slice(index+1,sometimes.length) ])
            else
                setSometimes([...sometimes.slice(0,index), {...sometimes[index], hint: hint}, ...sometimes.slice(index+1,sometimes.length)])
        }
    
        const setSometimesItem = (v: OotItemDto | null, index: number, indexItem: number) => {
    
            let items = clone([...sometimes]);
            if(indexItem === 1)
                items[index].hintItem1 = v;
            else if (indexItem === 2)
                items[index].hintItem2 = v;
        
            setSometimes(items);
    
      
        }
    
    
        const setGoalHintLocation = (v: LocationAutocompleteDto | null, i: number) => {
    
    
            if(i === goalHints.length -1)
                setGoalHints([...goalHints.slice(0,i), {goal: goalHints[i].goal, location: v, items: goalHints[i].items}])
            else if(i === 0)
                setGoalHints([{goal: goalHints[i].goal, location: v, items: goalHints[i].items}, ...goalHints.slice(i+1,goalHints.length) ])
            else
                setGoalHints([...goalHints.slice(0,i), {goal: goalHints[i].goal, location: v, items: goalHints[i].items}, ...goalHints.slice(i+1,goalHints.length) ])
    
        }
    
        const setGoalHintGoal = (v: BossDto | null, i: number) => {
            if(i === goalHints.length -1)
                setGoalHints([...goalHints.slice(0,i), {location: goalHints[i].location, goal: v, items: goalHints[i].items}])
            else if(i === 0)
                setGoalHints([{location: goalHints[i].location, goal: v, items: goalHints[i].items}, ...goalHints.slice(i+1,goalHints.length) ])
            else
                setGoalHints([...goalHints.slice(0,i), {location: goalHints[i].location, goal: v, items: goalHints[i].items}, ...goalHints.slice(i+1,goalHints.length) ])
    
        }
    
        const setGoalHintItems = (v: OotItemDto | null, index: number, indexItem: number) => {
    
            let items = clone([...goalHints[index].items]);
            items[indexItem] =  v;
            
    
            let goals = cloneDeep([...goalHints]);
    
            console.log(goals);
            goals[index].items = items;
    
            setGoalHints(goals);
    
      
        }

    return <Box position={"absolute"} top={20} left={100}>
        <PreventRefresh />
        <ReworkItemTracker top={50} left={0} />
        <Box display={"flex"} flexDirection={warp !== 0 ? "column" : "row"} position={"absolute"} top={260} left={10} width={250} height={300}>
            <ReworkChildSongTracker  a={true} cdown={true} cleft={true} cright={true} cup={true} display={warp === 0 ? "vertical" : "horizontal"} />
            <ReworkWarpSongTracker warpShuffle={warp === 0}  a={true} cdown={true} cleft={true} cright={true} cup={true} display={warp === 0 ? "vertical" : "horizontal"} />

        </Box>

        <ReworkDungeonTracker
            top={50}
            left={450}
            bkShuffle={true}
            keyShuffle={true}
            bossShuffle={true}
            dungeonShuffle={true}
            keyring={false}
            dungeons={dungeons}
            setDungeonValue={setDungeonValue}
            silverRupee={false}
            setSilverRupeesObtained={(v) => {}}
            silverRupeesObtained={[]}



        />
        <RewardRewardTracker
            top={50}
            left={200}
            rewards={rewards}
            setReward={setReward}
        />
        <Box display={"flex"} flexDirection={"column"} position={"absolute"} top={200} left={210} width={225}>
            <AdditionalItemTracker gerudoCardShuffle={gerudoCard === 0} openFountain={fountain === 0} adultTradeSequenceOnlyOne={true}/>
        </Box>
        <Box display={"flex"} flexDirection={"column"} position={"absolute"} top={270} left={210} width={225}>
            <ReworkTrialTracker trialActivated={trials > 0} 
                                setTrial={setTrialActivated} 
                                forestActivated={forestActivated}
                                fireActivated={fireActivated}
                                waterActivated={waterActivated}
                                shadowActivated={shadowActivated}
                                spiritActivated={spiritActivated}
                                lightActivated={lightActivated}
            />    
        </Box>
        <Box display={"flex"} flexDirection={"row"} position={"absolute"} flexWrap={"wrap"} top={370} left={210} width={200}>
            {MultiworldAwlays.map(h => {return <DefaultAlwaysHint hint={h} />})}
        </Box>
            <ReworkPathTracker woth={woth} top={500} left={0} goalHints={goalHints} setGoal={setGoalHintGoal} setLocation={setGoalHintLocation} setItem={setGoalHintItems} nbGoals={7} players={players}/>
            <Box position={"absolute"} top={500} left={800} display={"flex"} flexDirection={"column"}>
                <MatePathTracker players={players} woth={woth} />
                <MatePathTracker players={players} woth={woth} />
                <MatePathTracker players={players} woth={woth} />
                <MatePathTracker players={players} woth={woth} />
                <MatePathTracker players={players} woth={woth} />
                <MatePathTracker players={players} woth={woth} />
                <MatePathTracker players={players} woth={woth} />
                <MatePathTracker players={players} woth={woth} />
            </Box>
            <Box  position={"absolute"} top={500} left={1400}>
                <ShopsanityTracker shopOn/>
            </Box>
            <Box  position={"absolute"} top={50} left={1900}>
                <LightSphereTracker />
            </Box>
        <Box>
            <ReworkSometimesTracker top={50} left={1000} hints={sometimes} setHint={setSometimesHint} setState={setSometimesState} setItems={setSometimesItem} height={400}/>
        </Box>
        <Box position={"absolute"} top={450} left={1000} display={"flex"}>
            <Box display={"flex"}>
                {players[0]} <img src={Hookshot} alt="hook" width={32} height={32}/> <BaseLocationAutocomplete data={DefaultLocation} selection={hookPlayer1} additionalOnChange={(v) => setHookPlayer1(v)} sx={{width: "100px"}} />
            </Box>
            <Box display={"flex"}>
                {players[1]} <img src={Hookshot}  alt="hook" width={32} height={32}/> <BaseLocationAutocomplete data={DefaultLocation} selection={hookPlayer2} additionalOnChange={(v) => setHookPlayer2(v)} sx={{width: "100px"}}/>
            </Box>
            <Box display={"flex"}>
                {players[2]} <img src={Hookshot} alt="hook" width={32} height={32}/> <BaseLocationAutocomplete data={DefaultLocation} selection={hookPlayer3} additionalOnChange={(v) => setHookPlayer3(v)} sx={{width: "100px"}}/>
            </Box>
        </Box>
        <Box  position={"absolute"} top={820} left={0}> 
            <SettingsUiDisplay 
            
                index={gbk}
                setIndex={setGbk}
                setting={
                        {name: "GBK", states: [{name: "6 Meds", chance: 0},{name: "3 Stones", chance: 0}, {name: "Triforce Hunt 24", chance: 0}], type: "classic"}} 
                    width={200}
            />
            <SettingsUiDisplay 
                top={0}
                left={150}
                index={bridge}
                setIndex={setBridge}
                setting={
                        {name: "Bridge", states: [{name: "6 Meds", chance: 0},{name: "7 reward", chance: 0}, {name: "Triforce Hunt 24", chance: 0}], type: "classic"}} 
                    width={200}
            />
            <SettingsUiDisplay 
                top={0}
                left={300}
                index={scarecrow}
                setIndex={setScarecrow}
                setting={
                        {name: "Free Scarcrow", states: [{name: "On", chance: 0}], type: "classic"}} 
                    width={200}
            />
            <SettingsUiDisplay 
                top={0}
                left={450}
                index={token}
                setIndex={setToken}
                setting={
                        {name: "Tokensanity", states: [{name: "Dungeon", chance: 0}, {name: "Off", chance: 0}], type: "classic"}} 
                    width={200}
            />
            <Box position={"absolute"} top={0} left={600} width={"100px"}>
                <Switch checked={woth} value={woth} onClick={() => setWoth(!woth)} /> Woth
            </Box>
        </Box>
    </Box>
}

export default MultiworldTracker

const MatePathTracker = (props: {players: Array<string>, woth?: boolean}) => {
    return <Box display={"flex"} >
         <OotItemContextMenuButton />
                {!props.woth && <GoalAutocomplete />}
                <MultiworldPlayerAutocomplete data={props.players}  />
                <OotItemContextMenuButton />
                <OotItemContextMenuButton />
                <OotItemContextMenuButton />
                <Box marginRight={"15px"} />
                <OotItemContextMenuButton />
                <OotItemContextMenuButton />
                <OotItemContextMenuButton />
                <Box marginRight={"15px"} />
                <OotItemContextMenuButton />
                <OotItemContextMenuButton />
                <OotItemContextMenuButton />
    </Box>
}